import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { trackPageViewed, identifyUser } from '../utils/analytics';

const derivePage = (pathname: string): string => {
  if (pathname === '/') return 'landing';
  // Strip UUIDs so /projects/abc-123/documents/def-456 → /projects/documents
  const normalized = pathname.replace(/\/[0-9a-f-]{8,}/gi, '');
  const segment = normalized.replace(/^\//, '').replace(/\//g, '_') || 'landing';
  return segment;
};

export const usePageTracking = (): void => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id && user?.email) {
      identifyUser(user.id, user.email);
    }
    trackPageViewed(derivePage(location.pathname), user?.id);
  }, [location.pathname, user?.id, user?.email]);
};
